export default {"src":"/_next/static/media/crw.722a507e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};